import { Checkbox } from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLightbulb } from "@fortawesome/sharp-regular-svg-icons";

import { ChangeEventHandler, useEffect, useRef, useState } from "react";
import styles from "./provider-baa-form.module.scss";
import { BAA_COPY } from "./baaCopy";

type ProviderBAAFormProps = {
  onCheckboxClicked: ChangeEventHandler<HTMLInputElement>;
};

function ProviderBAAForm({ onCheckboxClicked }: ProviderBAAFormProps) {
  const [hasScrolledToBottom, setHasScrolledToBottom] = useState(false);
  const bottomRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setHasScrolledToBottom(true);
        observer.unobserve(bottomRef.current!);
      }
    });

    if (bottomRef.current) {
      observer.observe(bottomRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div className={styles.agreementInformation}>
        <div className={styles.icon}>
          <FontAwesomeIcon icon={faLightbulb} title="Information" />
        </div>
        <div className={styles.informationCopy}>
          <p className={styles.informationTitle}>{"What is this agreement"}</p>
          <p>
            {
              "By agreeing to this BAA, you confirm that Claimable will safeguard"
            }
            {
              "PHI, use it only for agreed-upon purposes, and take responsibility"
            }
            {"for any breaches."}
          </p>
        </div>
      </div>
      <div className={styles.agreementCopy}>
        {BAA_COPY}
        <div ref={bottomRef} />
      </div>
      <div className={styles.termsAndConditionsContainer}>
        <Checkbox
          label="I have read and agree to the Claimable BAA and service agreement and am authorized to agree on behalf of my organization"
          onChange={onCheckboxClicked}
          disabled={!hasScrolledToBottom}
          classNames={{
            body: styles.checkboxBody,
            inner: styles.checkboxContainer,
            input: styles.checkboxInput,
            icon: styles.checkboxIcon,
          }}
        />
      </div>
    </>
  );
}

export default ProviderBAAForm;
